import React from 'react';
import {List, Layout, NavLink} from 'components';
import {config} from 'helpers';

export function Sidebar() {
  return (
    <Layout.Sidebar className="smaller">
      <List className="link-list">
        <NavLink to={`/${config.clarityModule}/`} exact>Intro</NavLink>
        <NavLink to={`/${config.clarityModule}/how-are-you/`}>1. How are you</NavLink>
        <NavLink to={`/${config.clarityModule}/reality-check/`}>2. Reality Check</NavLink>
        <NavLink to={`/${config.clarityModule}/career/`}>3. Career</NavLink>
        <NavLink to={`/${config.clarityModule}/relationships/`}>4. Relationships</NavLink>
        <NavLink to={`/${config.clarityModule}/health/`}>5. Health</NavLink>
        <NavLink to={`/${config.clarityModule}/wealth/`}>6. Wealth</NavLink>
        <NavLink to={`/${config.clarityModule}/social/`}>7. Social</NavLink>
        <NavLink to={`/${config.clarityModule}/spirituality/`}>8. Spirituality</NavLink>
        <NavLink to={`/${config.clarityModule}/lifestyle/`}>9. Lifestyle</NavLink>
        <NavLink to={`/${config.clarityModule}/growth/`}>10. Growth</NavLink>
        <NavLink to={`/${config.clarityModule}/whats-next/`}>What's next</NavLink>
      </List>
    </Layout.Sidebar>
  );
}
